"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = CollaborationPageHeader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit");

function CollaborationPageHeader(_ref) {
  var showCollaborationModal = _ref.showCollaborationModal,
      showShareModal = _ref.showShareModal,
      members = _ref.members,
      resourceName = _ref.resourceName,
      _ref$actionPopupOptio = _ref.actionPopupOptions,
      actionPopupOptions = void 0 === _ref$actionPopupOptio ? [] : _ref$actionPopupOptio,
      secondaryContent = _ref.secondaryContent,
      darkMode = _ref.darkMode,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["showCollaborationModal", "showShareModal", "members", "resourceName", "actionPopupOptions", "secondaryContent", "darkMode"]),
      mergedActionPopupOptions = [{
    action: showShareModal,
    label: "Share ".concat(resourceName),
    isRed: !1
  }].concat((0, _toConsumableArray2["default"])(actionPopupOptions));
  return _react["default"].createElement(_uiKit.PageHeader, (0, _extends2["default"])({
    actionPopupOptions: mergedActionPopupOptions,
    darkMode: darkMode
  }, otherProps, {
    secondaryContent: _react["default"].createElement(_react["default"].Fragment, null, secondaryContent, members && members.length ? _react["default"].createElement(_uiKit.ResourceMembers, {
      showOwnerBadge: !0,
      members: members,
      imageSize: "40px",
      onAddIconClick: showCollaborationModal,
      darkMode: darkMode
    }) : null)
  }));
}